export const OfferTypesArray = ["Magazyn dedykowany", "Multimagazyn"];
export const OfferStatusesArray = [
  "Nowa",
  "Konsultowana",
  "Zaakceptowana",
  "Rezygnacja",
  "Anulowanie",
  "W trakcie wyceny",
  "Gotowa",
  "Brak",
  "Wycofana",
  "Zatwierdzona",
];
